import React, { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import LoadTop from "../Components/LoadTop";
import i18n from "../i18n";

const HomeTwo = lazy(() => import("./HomeTwo"));
const About = lazy(() => import("./About"));
const Blog = lazy(() => import("./Blog"));
const BlogDetails = lazy(() => import("./BlogDetails"));
const Offers = lazy(() => import("./Offers"));
const OfferDetails = lazy(() => import("./OfferDetails"));
const Branches = lazy(() => import("./Branches"));
const Spaces = lazy(() => import("./Spaces"));
const Space = lazy(() => import("./Space"));
const PackageSubscribe = lazy(() => import("./PackageSubscribe"));
const MeetingRoom = lazy(() => import("./MeetingRooms"));
const AcceptContract = lazy(() => import("./AcceptContract"));
const Destination = lazy(() => import("./Destination"));
const OfficeDetails = lazy(() => import("./OfficeDetails"));
const Branch = lazy(() => import("./Branch"));
const Profile = lazy(() => import("./Profile"));
const Error = lazy(() => import("./Error"));
const Contact = lazy(() => import("./Contact"));
const Gallery = lazy(() => import("./Gallery"));

function LanguageSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lang = pathname.startsWith("/ar") ? "ar" : "en";
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [pathname]);

  return null;
}

function PageLoader() {
  return <div className="text-center py-5">Loading...</div>;
}

function RouterPage() {
  return (
    <Router>
      <LanguageSync />
      <LoadTop />

      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomeTwo />} />
          <Route path="/en" element={<HomeTwo />} />
          <Route path="/ar" element={<HomeTwo />} />

          <Route path="/en/about" element={<About />} />
          <Route path="/ar/about" element={<About />} />

          <Route path="/en/blog" element={<Blog />} />
          <Route path="/ar/blog" element={<Blog />} />
          <Route path="/en/blog/:id" element={<BlogDetails />} />
          <Route path="/ar/blog/:id" element={<BlogDetails />} />

          <Route path="/en/single-offer/:id" element={<OfferDetails />} />
          <Route path="/ar/single-offer/:id" element={<OfferDetails />} />

          <Route path="/en/offers" element={<Offers />} />
          <Route path="/ar/offers" element={<Offers />} />

          <Route path="/en/branches" element={<Branches />} />
          <Route path="/ar/branches" element={<Branches />} />

          <Route path="/en/spaces" element={<Spaces />} />
          <Route path="/ar/spaces" element={<Spaces />} />

          <Route path="/en/space/:slug" element={<Space />} />
          <Route path="/ar/space/:slug" element={<Space />} />

          <Route path="/en/membership/:slug" element={<PackageSubscribe />} />
          <Route path="/ar/membership/:slug" element={<PackageSubscribe />} />

          <Route path="/en/meeting-room-booking" element={<MeetingRoom />} />
          <Route path="/ar/meeting-room-booking" element={<MeetingRoom />} />

          <Route path="/en/accept-contract/:slug" element={<AcceptContract />} />
          <Route path="/ar/accept-contract/:slug" element={<AcceptContract />} />

          <Route path="/en/spaces/:slug" element={<Destination />} />
          <Route path="/ar/spaces/:slug" element={<Destination />} />

          <Route path="/en/office-details/:slug" element={<OfficeDetails />} />
          <Route path="/ar/office-details/:slug" element={<OfficeDetails />} />

          <Route path="/en/branch/:slug" element={<Branch />} />
          <Route path="/ar/branch/:slug" element={<Branch />} />

          <Route path="/en/book/:slug" element={<OfficeDetails />} />
          <Route path="/ar/book/:slug" element={<OfficeDetails />} />

          <Route path="/en/profile" element={<Profile />} />
          <Route path="/ar/profile" element={<Profile />} />

          <Route path="/en/contact-us" element={<Contact />} />
          <Route path="/ar/contact-us" element={<Contact />} />

          <Route path="/en/gallery" element={<Gallery />} />
          <Route path="/ar/gallery" element={<Gallery />} />

          <Route path="/error" element={<Error />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default RouterPage;